import React from 'react'
import { observer } from 'mobx-react-lite'
import TableCell from '@mui/material/TableCell'
import TableSortLabel from '@mui/material/TableSortLabel'
import { Column } from '../CustomTable'
import { CustomTableStore, useCustomTableStore } from '../CustomTableStore'
import useCustomTableRenderLog from '../hooks/useCustomTableRenderLog'
import useStore from 'reusable/mobx-store-utils'

interface CustomTableHeaderCellProps<RowData extends AnyObject, RowStore> {
   column: Column<RowData, RowStore>
   index?: number
}

export const CustomTableHeaderCell = observer(function CustomTableHeaderCell
   <RowData extends AnyObject, RowStore>(props: CustomTableHeaderCellProps<RowData, RowStore>) {
   useCustomTableRenderLog('CustomTableHeaderCell')
   const customTableStore = useCustomTableStore<CustomTableStore<RowData, RowStore>>()

   const localStore = useStore(
      sp => ({
         onHeaderCellClick: () => {
            customTableStore.onHeaderCellClick &&
               sp.index !== undefined &&
               sp.index >= 0 &&
               customTableStore.onHeaderCellClick(sp.index)
         },
         get headerCellStyle() {
            const style = { ...sp.column?.headerStyle }
            style.position = 'sticky'
            style.borderCollapse = 'separate'
            style.top = customTableStore.headerCellTopValue
            // style.zIndex = 1
            return style
         },
         get sortActive() {
            return sp.index === customTableStore.columnSortingIndex
         },
         get sortDirection() {
            return customTableStore.sp.sortable ? customTableStore.columnSortingDirection : false
         },
      }),
      props
   )

   if (props.column.hidden) {
      return null
   }
   let title = null
   if (
      customTableStore.sp.sortable &&
      (props.column.sortable === undefined || props.column.sortable === true)
   ) {
      title = (
         <TableSortLabel
            active={localStore.sortActive}
            direction={localStore.sortDirection || undefined}
            onClick={localStore.onHeaderCellClick}>
            {props.column.title}
         </TableSortLabel>
      )
   } else {
      title = props.column.title
   }

   return (
      <TableCell
         variant="head"
         sortDirection={localStore.sortDirection}
         style={localStore.headerCellStyle}
         align={props.column.align}>
         {title}
      </TableCell>
   )
}
)
